import Vue from 'vue'

export default {
    namespaced: true,

    state: {
        fields: {
            terms: false,
            recaptcha: null,
        },

        valid: {
            terms: false,
            recaptcha: false,
        },

        errors: {
            terms: false,
            recaptcha: false,
        }
    },

    getters: {
        confirmationIsValid(state) {
            return Object.values(state.valid).reduce((accum, error) => accum && error, true)
        }
    },

    mutations: {
        clearErrors(state) {
            for(const error in state.errors) {
                if(!state.errors.hasOwnProperty(error)) continue;
                state.errors[error] = false
            }
        },

        setField(state, { name, value }) {
            console.log(state, name, value);
            Vue.set(state.fields, name, value)
            if(validation[name](state, value)){
                Vue.set(state.valid, name, true)
                Vue.set(state.errors, name, false)
            } else {
                Vue.set(state.valid, name, false)
            }
        },

        setError(state, { name, value }) {
            Vue.set(state.errors, name, value)
        },

        setValid(state, { name, value }) {
            Vue.set(state.valid, name, value)
        }
    }
}

const validation = {

    terms(state, value) {
        return value === true
    },

    recaptcha(state, value) {
        if(value === 'not-required') {
            return true
        }
        return !!value
    },
}
